// extracted by mini-css-extract-plugin
export default {"details-section":"DetailsSection_details-section__oEF60","back-button":"DetailsSection_back-button__sor68"};